import { Component, OnInit } from '@angular/core';
import { DataTaskService } from '../../../core/services/data-task.service';
import { CountryItem, LogisticService } from '../../../services/logistic.service';
import { StateService } from '../../../core/services/state.service';
import { Item } from '../../../core/components/listbox/listbox.component';

@Component({
  selector: 'tt-holidays',
  templateUrl: './holidays.component.html',
  styleUrls: ['./holidays.component.css']
})
export class HolidaysComponent implements OnInit {
    public year;

    public countryId;

    public selectListCountries: CountryItem[] = [];

    public selectListYears: Item[] = [];

    public itemsListHolidays: Item[] = [];

    constructor(private stateService: StateService, private datatask: DataTaskService, private logistic: LogisticService) {
        this.year = this.stateService.getStateParams()['year'];
        this.countryId = this.stateService.getStateParams()['country_id'];
    }

    private async loadCountries(): Promise<void> {
        this.selectListCountries = await this.logistic.getCountries();
    }

    private async loadYears(): Promise<void> {
        if (!!this.countryId) {
            this.selectListYears = await this.datatask.Post(563, { country_id: this.countryId });
        }
    }

    private async loadHolidays(): Promise<void> {
        if (!!this.year && !!this.countryId) {
            this.itemsListHolidays = await this.datatask.Post(564, {
                year: this.year,
                country_id: this.countryId
            });
        }
    }

    public goToFunc(state: any) {
        switch (state) {
            case 'holiday':
                this.stateService?.go('holiday', {
                    p2_holyday_keyno: '0',
                    country_id: this.countryId
                });
                break;
            default:
                break;
        }
    }

    public onChanged(_: string, id: any) {
        switch (id) {
            case 'year':
                this.loadHolidays();
                break;
            case 'countryId':
                this.loadYears();
                this.loadHolidays();
                break;
            default:
                break;
        }
    }

    private async init() {
        this.loadCountries();
        this.loadYears();
        this.loadHolidays();
    }

    ngOnInit() {
        this.init();
    }
}
